// extracted by mini-css-extract-plugin
export default {"section3":"Section3_section3__ZuQbI","noDataFound":"Section3_noDataFound__Dmhzt"};